$(function () {
    $(window).on('load resize orientationchange', function () {
        recognitionSlider();
    });

    function recognitionSlider() {
        var slider = $('.flex-split--recognition');
        if (window.matchMedia("(min-width: 768px)").matches) {
            if (slider.hasClass('slick-initialized')) {
                slider.slick('unslick');
            }
        }
        else {
            if (!slider.hasClass('slick-initialized')) {
                slider.slick({
                    infinite: true,
                    prevArrow: '.recognition__slide-prev',
                    nextArrow: '.recognition__slide-next',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    mobileFirst: true
                });
            }
        }
    }

    $('.testimonial-slider').slick({
        infinite: true,
        prevArrow: '.testimonial-slider__slide-prev',
        nextArrow: '.testimonial-slider__slide-next',
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true
    });


    handleCertCardClick();

    function handleCertCardClick() {
        var certCards = document.querySelectorAll(".certb-card");

        [].forEach.call(certCards, function (certCard) {
            certCard.addEventListener("click", function (e) {
                var clickedEl = e.target;
                var learnMoreBtn = certCard.querySelector(".certb-card__btn");
                var experienceLink = certCard.querySelector(".certb-card__experience a");
                var experienceLinkClicked = experienceLink && (clickedEl == experienceLink || experienceLink.contains(clickedEl));

                if (experienceLinkClicked) return;

                learnMoreBtn.click();
            });
        });
    }
});